// src/pages/AppointmentPage/PersonalTaxPlanningPage.tsx

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import api from "../../api/client";
import { InlineWidget } from "react-calendly";
import styles from "./PersonalTaxPlanningPage.module.scss";

const PersonalTaxPlanningPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [paymentCode, setPaymentCode] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showCalendly, setShowCalendly] = useState(false);
  const [showGuide, setShowGuide] = useState(false);
  const [userInfo, setUserInfo] = useState<{
    fullName?: string;
    email?: string;
  } | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessage("");
    try {
      const res = await api.post("/checkInvoice", {
        invoice: paymentCode,
      });
      if (res.data.valid) {
        setUserInfo(res.data.userInfo);
        setShowCalendly(true);
      } else {
        setErrorMessage(t("appointment.invalidInvoiceNumber"));
      }
    } catch (err) {
      console.error(err);
      setErrorMessage(t("appointment.submitPFail"));
    }
  };

  const handleBack = () => {
    navigate("/appointment");
  };

  return (
    <div className={styles.reviewPage}>
      <div className={styles.reviewContainer}>
        {!showCalendly ? (
          <>
            <h1>{t("appointment.personalTaxPlanning")}</h1>
            {!showGuide ? (
              <>
                <form onSubmit={handleSubmit} className={styles.reviewForm}>
                  <div className={styles.formLabel}>
                    <strong>
                      <label>{t("appointment.paymentCode")}</label>
                    </strong>
                    <input
                      type="text"
                      className={styles.inputField}
                      value={paymentCode}
                      onChange={(e) => setPaymentCode(e.target.value)}
                      required
                    />
                  </div>
                  {errorMessage && (
                    <p className={styles.errorMessage}>{errorMessage}</p>
                  )}
                  <div className={styles.buttons}>
                    <button type="button" onClick={handleBack}>
                      {t("general.back")}
                    </button>
                    <button type="submit">{t("general.submit")}</button>
                  </div>
                </form>
                <div className={styles.noCodeLink}>
                  <button type="button" onClick={() => setShowGuide(true)}>
                    {t("appointment.noCode")}
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className={styles.guideContainer}>
                  <h2>{t("appointment.getReservationCode")}</h2>
                  <div className={styles.steps}>
                    <div className={styles.step}>
                      <h3>{t("appointment.step1Title")}</h3>
                      <p>
                        {t("appointment.step1Content")}{" "}
                        <a
                          href="https://unlimitedadvisory.taxdome.com/signup"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          sign up here
                        </a>
                      </p>
                    </div>
                    <div className={styles.step}>
                      <h3>{t("appointment.step2Title")}</h3>
                      <p>{t("appointment.step2Content")}</p>
                    </div>
                    <div className={styles.step}>
                      <h3>{t("appointment.step3Title")}</h3>
                      <p>{t("appointment.step3Content")}</p>
                    </div>
                    <div className={styles.step}>
                      <h3>{t("appointment.step4Title")}</h3>
                      <p>{t("appointment.step4Content")}</p>
                    </div>
                    <div className={styles.step}>
                      <h3>{t("appointment.step5Title")}</h3>
                      <p>{t("appointment.step5Content")}</p>
                    </div>
                  </div>
                  <button
                    className={styles.backButton}
                    onClick={() => setShowGuide(false)}
                  >
                    {t("general.back")}
                  </button>
                </div>
              </>
            )}
          </>
        ) : (
          <>
            <h1>{t("appointment.selectTimeReview")}</h1>
            <p className="referral-text">{t("appointment.yourinvoice")}</p>
            <p className="referral-text">
              {t("appointment.yourReservationCode")}
              {": "}
              <strong style={{ color: "red" }}>{paymentCode}</strong>
            </p>
            <hr className={styles.divider} />
            <div style={{ marginTop: "10px" }}>
              <InlineWidget
                url="https://calendly.com/ruifan-wu/tax-consulting"
                styles={{ height: "800px" }}
                prefill={{
                  name: userInfo?.fullName,
                  email: userInfo?.email,
                  customAnswers: {
                    a1: paymentCode, // 假设 a1 是在 Calendly 中设置的发票号码字段
                  },
                }}
              />
            </div>
            {/* <button style={{ marginTop: "20px" }} onClick={handleBack}>
              {t("general.back")}
            </button> */}
          </>
        )}
      </div>
    </div>
  );
};

export default PersonalTaxPlanningPage;
